import { ErrorKey } from '../app-active-error/ErrorKey';
import StandardError from '../app-active-error/StandardError';
import { jsx as _jsx } from "react/jsx-runtime";
export const RecaptchaMissingInformationErrorView = () => {
  const errorKey = ErrorKey.InternalError;
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey
  });
};